import { useState, useEffect, useCallback } from 'react'

interface CountdownValues {
  hours: string
  minutes: string
  seconds: string
}

const STORAGE_KEY = 'cortisol45_deadline'

export function useCountdown(): CountdownValues {
  const getDeadline = useCallback((): number => {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      return parseInt(stored, 10)
    }
    const deadline = Date.now() + 23 * 3600000 + 59 * 60000 + 59 * 1000
    localStorage.setItem(STORAGE_KEY, String(deadline))
    return deadline
  }, [])

  const [deadline] = useState<number>(getDeadline)
  const [values, setValues] = useState<CountdownValues>({
    hours: '23',
    minutes: '59',
    seconds: '59',
  })

  useEffect(() => {
    function update() {
      const remaining = deadline - Date.now()
      if (remaining <= 0) {
        setValues({ hours: '00', minutes: '00', seconds: '00' })
        return
      }
      const h = Math.floor(remaining / 3600000)
      const m = Math.floor((remaining % 3600000) / 60000)
      const s = Math.floor((remaining % 60000) / 1000)
      setValues({
        hours: String(h).padStart(2, '0'),
        minutes: String(m).padStart(2, '0'),
        seconds: String(s).padStart(2, '0'),
      })
    }

    update()
    const interval = setInterval(update, 1000)
    return () => clearInterval(interval)
  }, [deadline])

  return values
}
